<template>
  <div class="uploadWrapper">
    <div class="upload-form">
      <div class="l">
        <div class="row">
          <div class="s">
            <!-- 上传成功提示 -->
            <div v-if="uploadVideoStatus === 'succ'" class="upload-video-succ">
              <div
                :style="`background-image:url(${form.video_preview_jpg});`"
                class="pic"
              />
              <span
                v-if="!originateClient"
                class="btn-remove"
                @click="handleRemoveVideoResource"
              >
                <i class="el-icon-delete" />
              </span>
              <i class="icon-upload-succ" />
              <p class="upload-succ-text">
                上传成功
              </p>
            </div>
            <!-- 上传过程中提示 -->
            <div
              v-else-if="uploadVideoStatus === 'process'"
              class="upload-video-process"
            >
              <Loading :rotate="uploadComplete" class="loading-progress" />
              <template v-if="uploadComplete < 100">
                <p class="upload-process-text">
                  上传中({{ uploadComplete }}%)
                </p>
                <p v-if="uploadSpeed" class="upload-speed">
                  上传速率 {{ uploadSpeed }}
                </p>
              </template>
              <p v-else class="upload-process-text">
                正在处理中...
              </p>
            </div>
            <!--  上传组件 -->
            <el-upload
              v-else
              :http-request="handleVideoUpload"
              accept=".mp4"
              action
              class="upload-video"
              drag
            >
              <i class="icon-upload" />
              <p class="upload-info">
                将动态壁纸视频拖拽到此处
              </p>
              <p class="upload-sub">
                或
                <span class="btn">浏览</span>以选择文件
              </p>
              <p class="upload-tip">
                请上传壁纸<strong class="upload-tip__picName"> {{ params.wname }} </strong> 的手机版本<br>
                视频尺寸不小于{{ videoWidth }}x{{
                  videoHeight
                }}，支持MP4格式，视频不要超过50M
              </p>
            </el-upload>
          </div>
        </div>
        <div class="ctrl">
          <span class="btn-publish" @click="submitHandler">提交审核</span>
        </div>
      </div>
    </div>
    <!-- 错误提示和警告提示框 -->
    <div v-if="confirmDialogText" class="confirm-dalog-wrap">
      <ConfirmDialog
        :confirm-text="confirmDialogConfirmText"
        :text="confirmDialogText"
        @close="handleConfirmDialogClose"
        @confirm="handleConfirmDialogConfirm"
      />
    </div>
  </div>
</template>

<script>
import * as SparkMD5 from 'spark-md5'
import { mapState } from 'vuex'

import {
  doCheckIsExists,
  // doUpload,
  // fetchCateList,
  // findTagList,
  // doCommit,
  doCheckUploadLimit,
  submitMobilePaper,
  uploadMultipartComplete,
  uploadMultipartInit,
  uploadMultipartUpload,
} from '@/api/upload'
import { parseSpeed } from '@/utils/shared'
import ConfirmDialog from '@/components/dialog/ConfirmDialog'
import Loading from '@/components/Loading'

export default {
  name: 'Upload',
  components: {
    ConfirmDialog,
    Loading,
  },
  props: {
    params: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      uploadVideoStatus: 'wait', // 'wait','process'
      confirmDialogText: '',
      confirmDialogConfirmText: '我知道了',
      /** 上传相关 */
      uploadComplete: 0, // 上传进度
      uploadSpeed: '',
      uploadPreLoaded: 0,
      uploadLoaded: 0,
      speedTimer: null,

      chunkSize: 2097152, // 2M 作为一个chunk
      fileMaxSize: 50 * 1024 * 1024, // 50M
      videoWidth: 720,
      videoHeight: 1280,
      form: {
        ptype: '1', // 1 or 0 付费类型
      },
      previewUserUpload: false, // todo:可以干掉
      originateClient: false, // 是否来源于客户端
      //
      uploaded_paper_url: '',
      uploaded_resource_id: '',
      uploaded_preview_jpg: '',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
    userPtype() {
      return this.form.ptype
    },
  },
  methods: {
    /**
     * @param {String} md5
     * @param {Object} file
     * @param  {Array} fileData  存储文件分片的数组
     *
     */

    async multipartUpload(md5, file, fileData) {
      const params = {
        common: this.common,
        file_name: file.name,
        md5,
        file_type: 'live',
      }
      this.uploadVideoStatus = 'process'
      try {
        // 计算进度
        this.uploadComplete = 0
        // 计算速率
        this.uploadSpeed = ''
        this.uploadPreLoaded = 0
        this.uploadLoaded = 0
        // let time = 0
        this.speedTimer = setInterval(() => {
          // time++
          const speed = (this.uploadLoaded - this.uploadPreLoaded) / 1024
          if (speed) {
            this.uploadSpeed = parseSpeed(speed * 200)
          }
          // console.log('time:', time, 'speed:', speed, this.uploadSpeed, this.uploadPreLoaded)
          this.uploadPreLoaded = this.uploadLoaded
        }, 2000)
        // todo: 分片上传之前，先获取上传id
        const initRes = await uploadMultipartInit(params)
        if (!initRes.resp_common || initRes.resp_common.ret) {
          return
        }
        let completeLoaded = 0

        const uploadId = initRes.data.upload_id
        for (let i = 0, len = fileData.length; i < len; i++) {
          const item = fileData[i]

          // let nextSize = Math.min((i + 1) * this.chunkSize, file.size)

          const formData = new FormData()
          const blobData = new Blob([item])
          formData.append('file_part', blobData)
          formData.append('open_id', this.common.open_id)
          formData.append('token', this.common.token)
          formData.append('upload_id', uploadId)
          formData.append('part_size', blobData.size)
          formData.append('part_number', i + 1)
          // todo：上传接口，并定义一个回调，回调貌似没有用到
          const uploadRes = await uploadMultipartUpload(formData, {
            onUploadProgress: (progressEvent) => {
              const complete
                = ((progressEvent.loaded / progressEvent.total) * 100) | 0

              this.uploadLoaded = completeLoaded + progressEvent.loaded
              this.uploadComplete = ((this.uploadLoaded / file.size) * 100) | 0
              if (complete === 100) {
                completeLoaded += progressEvent.loaded
              }
            },
          })

          if (!uploadRes.resp_common || initRes.resp_common.ret) {
            return
          }
        }

        this.uploadComplete = 100
        clearInterval(this.speedTimer)

        params.upload_id = uploadId
        const completeRes = await uploadMultipartComplete(params)
        // completeRes：上传成功之后的结果
        if (!completeRes.resp_common || completeRes.resp_common.ret) {
          return
        }

        // console.log('complete res:', completeRes)
        this.form.resource_id = completeRes.data.resource_id
        this.form.paper_url = completeRes.data.resource_url
        if (!this.previewUpload) {
          this.form.preview_jpg = completeRes.data.preview_jpg
        }
        this.form.video_preview_jpg = completeRes.data.preview_jpg
        this.uploadVideoStatus = 'succ'
      } catch (err) {
        this.uploadVideoStatus = 'wait'

        if (err.resp_common) {
          if (err.resp_common.ret === 4001002) {
            return
          }

          this.confirmDialogText = err.resp_common.msg
          return
        }

        this.confirmDialogText = err.message
      }

      clearInterval(this.speedTimer)
    },
    /**
     * @param {String} md5 检查服务端md5 是否存在
     * @return {Promise}
     */
    async doCheckIsExists(md5) {
      try {
        return await doCheckIsExists({
          common: this.common,
          md5,
        })
      } catch (err) {
        // TODO
      }
    },

    /**
     * @param {String} md5 判断是否已经上传过,如果上传过直接返回
     * @return {Boolean}
     */
    async checkMd5(md5) {
      try {
        const res = await this.doCheckIsExists(md5)
        const is_exist
          = res.is_exist !== undefined ? res.is_exist : res.data.is_exist
        if (is_exist) {
          if (res.data && res.data.resource_id) {
            this.form.resource_id = res.data.resource_id
            this.form.paper_url = res.data.resource_url
            if (!this.previewUserUpload) {
              this.form.preview_jpg = res.data.preview_jpg
            }
            this.form.video_preview_jpg = res.data.preview_jpg
            this.uploadVideoStatus = 'succ'
          } else {
            this.confirmDialogText = '已经上传过该视频，无需重复上传'
          }
          return false
        }
        return true
      } catch (err) {
        // TODO
      }
    },
    async handleCheckUploadOverLimit() {
      try {
        await doCheckUploadLimit({
          common: this.common,
        })
        return false
      } catch (err) {
        const ERROR_MAP = {
          4911026: '上传超过单日5张限制',
        }
        if (err.resp_common && ERROR_MAP[err.resp_common.ret]) {
          return true
        }
      }

      return false
    },
    checkVideoWidthHeight(file) {
      const $video = document.createElement('video')
      try {
        return new Promise((resolve /* , reject */) => {
          $video.onloadedmetadata = () => {
            const { videoWidth, videoHeight } = $video
            if (videoWidth === 0 || videoHeight === 0) {
              resolve(true)
              return
            }

            if (
              videoWidth >= this.videoWidth
              && videoHeight >= this.videoHeight
            ) {
              resolve(true)
              return
            }

            resolve(false)
          }

          $video.onerror = () => {
            // this.confirmDialogText = `请上传编码格式为H264的MP4文件`
            // reject(false)
            resolve(true)
          }

          try {
            $video.src = URL.createObjectURL(file)
          } catch (err) {
            resolve(true)
          }
        })
      } catch (err) {
        return true
      }
    },
    async handleVideoUpload($event) {
      // 采用slice 上传
      const blobSlice = File.prototype.slice
      const file = $event.file
      if ((await this.handleCheckUploadOverLimit()) === true) {
        this.confirmDialogText = '您今日已上传5张壁纸，请明天再来哦~'
        return
      }
      if (!file.name || !file.name.match(/\.mp4$/gi)) {
        this.confirmDialogText = '请上传MP4格式文件'
        return
      }
      // 检查视频分辨率
      if ((await this.checkVideoWidthHeight(file)) === false) {
        this.confirmDialogText = `请上传大小不小于${this.videoWidth}*${this.videoHeight}的视频文件`
        return
      }
      if (file.size > this.fileMaxSize) {
        this.confirmDialogText = '上传的视频不能超过 50M'
        return
      }
      const chunkSize = this.chunkSize // chunk 大小
      const chunks = Math.ceil(file.size / chunkSize) // chunk 数量
      let currentChunk = 0 //
      const spark = new SparkMD5.ArrayBuffer()
      const fileReader = new FileReader()
      const fileData = []
      // fileReader 监听
      fileReader.onload = async (e) => {
        // console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        spark.append(e.target.result)
        fileData.push(e.target.result)
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          // console.log('finished loading', spark.end())
          const md5 = spark.end()
          if (await this.checkMd5(md5)) {
            // todo： 如果已经上传过该视频，这个接口就不会调用
            this.multipartUpload(md5, file, fileData)
          }
        }
      }
      // trigger fileReader.onload
      function loadNext() {
        const start = currentChunk * chunkSize
        const end
          = start + chunkSize >= file.size ? file.size : start + chunkSize
        // fileReader 每次读取2M
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }

      loadNext()
    },
    handleConfirmDialogClose() {
      if (this.form.commit) {
        this.form = {}
        this.uploadVideoStatus = 'wait'
        this.originateClient = false
      }

      this.confirmDialogText = ''
      this.confirmDialogConfirmText = '我知道了'
    },
    handleRemoveVideoResource() {
      this.form.resource_id = 0
      this.form.paper_url = ''
      this.uploadVideoStatus = 'wait'
    },
    handleConfirmDialogConfirm() {
      this.handleConfirmDialogClose()
      this.$emit('submitPic')
    },
    submitHandler() {
      const requestData = {
        common: {
          token: this.common.token,
          open_id: this.common.open_id,
        },
        paper_url: this.form.paper_url, // 0:只取动态壁纸。1:动态壁纸跟scene一起取，2: scene壁纸，3: 静态壁纸
        resource_id: this.form.resource_id, // 是共有的resource_id
        wid_for_pc: this.params.wid,
        preview_jpg: this.form.video_preview_jpg,
      }
      if (
        this.form.paper_url
        && this.form.resource_id
        && this.form.video_preview_jpg
      ) {
        submitMobilePaper(requestData)
          .then((res) => {
            console.log(res)
            if (res.resp_common && !res.resp_common.ret) {
              this.confirmDialogText
                = '提交成功，壁纸进入审核流程，<br/>审核结果将通过元气壁纸消息中心通知您哦'
              this.form.commit = true
            }
          })
          .catch((err) => {
            this.form.commit = true
            if (err.resp_common) {
              this.confirmDialogText = err.resp_common.msg
            } else {
              this.confirmDialogText = err.message
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.uploadWrapper {
  // width: 645px;
  // min-height: 640px;
  $uploadAreaWidth: 500px;
  $uploadAreaHeight: 320px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  .upload-form {
    display: flex;
    align-self: center;
    padding-bottom: 20px;
    .l {
      width: 100%;
      .row {
        .error {
          font-style: normal;
          font-size: 12px;
          color: #f41c83;
        }
        .s {
          .upload-video {
            position: relative;
            width: $uploadAreaWidth;
            height: $uploadAreaHeight;
            margin: 0 auto;
            border: 2px dashed #a5a5a5;
            border-radius: 10px;
            ::v-deep .el-upload-dragger {
              // display: block;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              width: auto;
              height: auto;
              border: none;
              &.is-dragover {
                border: none;
              }
            }
            ::v-deep .el-upload-list {
              display: none;
            }
            .icon-upload {
              display: block;
              margin: 30px auto;
              width: 163px;
              height: 107px;
              background: url('~@/assets/images/icon-upload.png') 0 0 no-repeat;
            }
            .upload-info {
              margin-bottom: 8px;
              font-weight: 700;
              font-size: 16px;
              color: #333;
            }
            .upload-sub {
              font-size: 12px;
              color: #333;
              .btn {
                display: inline-block;
                width: 45px;
                height: 20px;
                margin: 0 5px;
                line-height: 20px;
                text-align: center;
                font-weight: 700;
                background: #f5b903;
                border-radius: 2px;
                color: #333;
              }
            }
            .upload-tip {
              margin-top: 50px;
              font-size: 12px;
              line-height:20px;
              // font-weight: 700;
              color: #a5a5a5;
              &__picName{
                color: #f5b903;
              }
            }
          }
          .upload-video-succ {
            position: relative;
            // width: $uploadAreaWidth;
            // height: 404px;
            height: $uploadAreaHeight;
            .pic {
              width: 100%;
              height: 100%;
              overflow: hidden;
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
              opacity: 0.2;
            }
            .btn-remove {
              z-index: 2;
              position: absolute;
              right: 0px;
              top: 0px;
              width: 36px;
              height: 36px;
              line-height: 36px;
              text-align: center;
              font-size: 14px;
              background: #333;
              border-radius: 4px;
              color: #999;
              cursor: pointer;
            }
            .icon-upload-succ {
              z-index: 2;
              position: absolute;
              left: 50%;
              top: 50%;
              width: 163px;
              height: 107px;
              margin: -70px 0 0 -81px;
              background: url('~@/assets/images/icon-upload-succ.png') 0 0
                no-repeat;
            }
            .upload-succ-text {
              z-index: 2;
              position: absolute;
              top: 245px;
              left: 0;
              right: 0;
              text-align: center;
              font-size: 16px;
              color: #333;
            }
          }
          .upload-video-process {
            .loading-progress {
              position: relative;
              margin: 0 auto;
              width: 107px;
              /* height: 107px; */
              border-radius: 50%;
              box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);
            }
            .upload-process-text {
              text-align: center;
              margin-top: 20px;
            }
            .upload-speed {
              text-align: center;
              margin-top: 20px;
            }
          }
        }
      }
      .ctrl {
        text-align: center;
        margin: 20px 20px 0 0;
        .btn-publish {
          display: inline-block;
          width: 185px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          background: #f5b903;
          border-radius: 8px;
          color: #333333;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
